import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { translations, LANGUAGES } from "../i18n/translations";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "tr";
    const stored = localStorage.getItem("mayak_lang");
    return stored && translations[stored] ? stored : "tr";
  });

  useEffect(() => {
    localStorage.setItem("mayak_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let value = translations[lang];
      for (const p of parts) {
        if (value && typeof value === "object" && p in value) {
          value = value[p];
        } else {
          return path;
        }
      }
      return value;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, languages: LANGUAGES }), [lang, t]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
